import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Paper,
  Fade,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import baseUrl from "../../config/baseUrl";
import { useStateContext } from "../../context/ContextProvider";
import logo from "../../assets/images/merchantnewlogo.svg";

const TestSession = () => {
  const [passKey, setPassKey] = useState("");
  const { setIsLoginUser, setAccoutType } = useStateContext();
  const navigate = useNavigate();
  const { user_id } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const validPassKeys = [
    "8j&K3#fB2@Lw!P9z",
    "Y5$J2!q8t*R4wB7&",
    "pX7@l#1Q8^zZ3w#9",
    "G6&n7^B!5m#T2y8@",
  ];

  const handleLogin = (data) => {
    setIsLoginUser(data.token);
    sessionStorage.setItem("user", data.token);
    sessionStorage.setItem("timeZone", JSON.stringify({ name: "India", timeZone: "Asia/Kolkata" }));
    sessionStorage.setItem("userName", data.name);
    sessionStorage.setItem("accoutType", data?.account_type);
    sessionStorage.setItem("usercode", data.usercode);
    sessionStorage.setItem("mer", data?.id);
    if(data?.account_type === 1 || data?.account_type === 0) {
      navigate("/DepositPortal/merchant_deposits");
    } else {
      navigate("/DepositPortal/dashboard");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validPassKeys.includes(passKey)) {
      return alert("Invalid pass key");
    }

    if (!user_id) {
      return alert("User ID missing");
    }

    try {
      const response = await axios.get(`${baseUrl}/merchant-test-session/${user_id}`);
      const data = response.data.data;
      handleLogin(data);
    } catch (error) {
      alert("Session failed or user not found");
    }
  };

  return (
    <Box
      minHeight="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      px={2}
      sx={{
        background: "linear-gradient(to right, #f0f2f5, #e0eafc)",
      }}
    >
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} sm={10} md={6} lg={4}>
          <Fade in timeout={600}>
            <Paper
              elevation={6}
              sx={{
                p: 4,
                borderRadius: 4,
                backgroundColor: "#fff",
                boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Box mb={3} textAlign="center">
                <img
                  src={logo}
                  alt="Logo"
                  style={{
                    width: isMobile ? "180px" : "250px",
                    margin: "auto",
                  }}
                />
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  color="primary"
                  mt={2}
                >
                  Test Session Login
                </Typography>
                <Typography variant="body2" color="text.secondary" mt={1}>
                  Enter the secret pass key to continue.
                </Typography>
              </Box>

              <form onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  label="Enter Pass Key"
                  variant="outlined"
                  type="password"
                  value={passKey}
                  onChange={(e) => setPassKey(e.target.value)}
                  required
                  sx={{ mb: 3 }}
                />
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  color="primary"
                  size="large"
                  sx={{
                    py: 1.5,
                    fontWeight: "bold",
                    fontSize: "1rem",
                    textTransform: "none",
                    borderRadius: 2,
                    ":hover": {
                      backgroundColor: theme.palette.primary.dark,
                    },
                  }}
                >
                  Submit
                </Button>
              </form>
            </Paper>
          </Fade>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TestSession;
